import React, { useEffect, useState } from 'react';
import {
  GetCompanyWiseInventoryData,
  GetProductWiseinventoryData,
} from '../../screen/distributor/action/util_action';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Divider,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { toast } from 'react-toastify';
import NoData from './NoData';
import { useDispatch, useSelector } from 'react-redux';
import { unitCaseEnum } from '../../utils/settings';
import CartBadge from './CartBadge';
import { useLocation, useNavigate } from 'react-router-dom';
import { FilterAlt } from '@mui/icons-material';
import { fetchSkuFilterAction } from '../APIs/action';
import { FilterComponent } from '../FMCG/FilterComponent';
import AddRemoveQtyButton from './AddRemoveQtyButton';
import { set } from 'lodash';
import { useCleverTapPageTracking } from '../../utils/clevertap';


export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  '&.Mui-selected': {
    backgroundColor: 'white',
    borderColor: '#f49d3f',
    color: '#f49d3f',
    margin: '0px 3px',
    fontWeight: 700,
    border: '1px solid #f49d3f',
    '&:hover': {
      backgroundColor: 'rgba(244, 157, 63, .1)',
    },
  },
  '&:not(.Mui-selected)': {
    backgroundColor: 'white',
    color: 'black',
    borderColor: 'black',
    margin: '0px 3px',
    fontWeight: 700,
    '&:hover': {
      backgroundColor: 'lightgray',
    },
  },
}));
const Inventory = () => {
  // Add CleverTap page tracking
  useCleverTapPageTracking('Inventory Page', 'inventory');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const company_id = location.state?.companyId;
  const isFromSelltoBuyer = location.state?.isFromSelltoBuyer || false;
  const { unitCaseWise, isSellToBuyer, cartItemList } = useSelector((state) => {
    return {
      unitCaseWise: state.fmcgReducer.unitCaseWise,
      isSellToBuyer: state.fmcgReducer.isSellToBuyer,
      cartItemList: state.fmcgReducer.cartItemList,
    };
  });

  const isMobile = useMediaQuery('(max-width: 768px)');
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [selectedCompanyData, setSelectedCompanyData] = useState({});
  const [companies, setCompanies] = useState([]);
  const [products, setProducts] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedFiltersList, setSelectedFiltersList] = useState([]);
  const [totalAvailableQty, setTotalAvailableQty] = useState(null);
  const [totalBlockedQty, setTotalBlockedQty] = useState(null);
  const [toggleSellToBuyer, setToggleSellToBuyer] = useState(1);
  const [inventoryMessage, setInventoryMessage] = useState(null);
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    
    // Track drawer close event (removed)

    setIsDrawerOpen(open);
  };

  const getCompanyWiseInventory = async () => {
    setIsLoading(true);
    const { error, data } = await GetCompanyWiseInventoryData();
    setIsLoading(false);

    if (!error) {
      setCompanies(data);
      let index = data.findIndex((ele) => ele.company_id == company_id);
      if (index == -1) index = 0;
      setSelectedCompany(data[index]?.company_id);
      const toggleList = [
        { value: 0, label: data[index]?.allocable_quantity?.unit },
        {
          value: 1,
          label: data[index]?.allocable_quantity?.base_unit,
        },
      ];
      setAlignment(toggleList[1]?.value);
      data[index]?.allocable_quantity?.unit &&
        data[index]?.allocable_quantity?.base_unit &&
        setToggleButtonList(toggleList);

      setSelectedCompanyData(data[index]);
      dispatch({ type: 'SET_SELLER_ID', data: data[index]?.company_id });
    }
  };
  useEffect(() => {
    getCompanyWiseInventory();
    dispatch({ type: 'FMCG_UNIT_CASE_WISE', data: unitCaseEnum['UNIT'] });
  }, []);

  const handleCompanyChange = (event) => {
    const selectedCompanyData = companies.find(
      (item) => item.company_id === event.target.value,
    );

    // Track company selection (removed)

    const toggleList = [
      { value: 0, label: selectedCompanyData?.allocable_quantity?.unit },
      {
        value: 1,
        label: selectedCompanyData?.allocable_quantity?.base_unit,
      },
    ];
    setAlignment(toggleList[1]?.value);
    selectedCompanyData?.allocable_quantity?.unit &&
    selectedCompanyData?.allocable_quantity?.base_unit
      ? setToggleButtonList(toggleList)
      : setToggleButtonList([]);
    setSelectedCompanyData(selectedCompanyData);
    setSelectedFiltersList([]);
    setSelectedCompany(event.target.value);
    dispatch({
      type: 'CLEAR_CART',
    });
    dispatch({ type: 'FMCG_UNIT_CASE_WISE', data: unitCaseEnum['UNIT'] });
    dispatch({ type: 'SET_SELLER_ID', data: event.target.value });
  };
  const getProductInventory = async () => {
    setIsLoading(true);
    const { error, data } = await GetProductWiseinventoryData({
      manufacturer_id: selectedCompany,
      product_filters: selectedFiltersList.join('~'),
    });
    setIsLoading(false);
    if (!error) {
      if (data.length > 0) {
        setProducts(data[0].inventory_list);
        setInventoryMessage(data[0].message);
      }
      else {
        setProducts([]);
        selectedFiltersList.length > 0
          ? toast.error('No Inventory found for selected filters')
          : toast.error('No Inventory found for selected company');
      }
    } else toast.error(error);
  };
  useEffect(() => {
    if (!selectedCompany) return;
    getProductInventory();
  }, [selectedCompany, selectedFiltersList]);
  const [toggleButtonlist, setToggleButtonList] = useState([]);
  const [alignment, setAlignment] = useState(toggleButtonlist[1]?.value);
  const handleToggleSellTobuyer = (event, newAlignment) => {
    if (newAlignment !== null) {
      // Track toggle between View Inventory and Sell to Buyer

      setToggleSellToBuyer(newAlignment);
      dispatch({
        type: 'CLEAR_CART',
      });
      dispatch({
        type: 'FMCG_IS_SELL_TO_BUYER',
        data: Boolean(Number(newAlignment)),
      });
    }
  };
  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      dispatch({
        type: 'CLEAR_CART',
      });
      dispatch({
        type: 'FMCG_UNIT_CASE_WISE',
        data: !newAlignment ? unitCaseEnum['CASE'] : unitCaseEnum['UNIT'],
      });

      // Track unit/case toggle

      setAlignment(newAlignment);
    }
  };
  const updateProdQty = (payload) => {
    const { type, data, inputValue } = payload;

    // Track quantity changes
    if (type === 'ADD') {
    } else if (type === 'REMOVE') {
      const currentQty = cartItemList.find(item => item.product_info.product_id === data.product_info.product_id)?.sellToBuyerQty?.qty || 0;
    }

    dispatch({
      type: 'UPDATE_PROD_QTY',
      data: {
        type: type,
        data: data,
        inputValue: inputValue,
      },
    });
  };
  const getQuantityInCasesUnit = (
    quantity_in_metric_ton,
    quantity_in_bags,
    multiplier,
    is_inventory_homogeneous,
    unit,
    base_unit,
  ) => {
    if (is_inventory_homogeneous) {
      return quantity_in_metric_ton;
    } else {
      const cases = Math.floor(quantity_in_bags / multiplier);
      const units = quantity_in_bags % multiplier;
      return `${cases} ${unit} ${units} ${base_unit}`;
    }
  };
  const [filters, setFilters] = useState([]);

  const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);
  const toggleFilterDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setIsFiltersModalOpen(open);
  };
  const getFilters = async () => {
    let params = {
      query: {
        term: {
          company_id: Number(selectedCompany),
        },
      },
      size: 500,
    };
    const { data, error } = await fetchSkuFilterAction('sku-master', params);

    if (!error) {
      setFilters(data.category_filters);
    }
  };
  useEffect(() => {
    getFilters();
  }, [selectedCompany]);
  useEffect(() => {
    const totalBlockedQty = alignment
      ? products.reduce(
          (acc, item) => acc + item.blocked_quantity.quantity_in_bags,
          0,
        )
      : products.reduce(
          (acc, item) => acc + item.blocked_quantity.quantity_in_metric_ton,
          0,
        );
    const totalAvailableQty = alignment
      ? products.reduce(
          (acc, item) => acc + item.allocable_quantity.quantity_in_bags,
          0,
        )
      : products.reduce(
          (acc, item) => acc + item.allocable_quantity.quantity_in_metric_ton,
          0,
        );
    setTotalBlockedQty(totalBlockedQty);
    setTotalAvailableQty(totalAvailableQty);
  }, [products, alignment]);
  const showPriceColumn =
    !selectedCompanyData?.is_inventory_homogeneous &&
    products.some((row) => Number(row?.price_info?.mrp) > 0);

  return (
    <Box sx={{ position: 'relative' }}>
      <Container
        maxWidth='true'
        sx={{ pl: '1rem', py: '2rem' }}
      >
        {isMobile && (
          <Grid
            item
            xs={12}
            sm={8}
            md={9}
            sx={{
              display: { sm: 'block', md: 'flex' },
              justifyContent: { md: 'flex-end' },
              width: '100%',
              marginBottom: { xs: '2rem' },
            }}
          >
            <ToggleButtonGroup
              value={toggleSellToBuyer}
              exclusive
              onChange={handleToggleSellTobuyer}
              aria-label='text alignment'
              sx={{
                width: '100%',
                backgroundColor: 'none',
              }}
            >
              <ToggleButton
                value={0}
                aria-label='Inventory'
                sx={{
                  flex: 1,
                  border: 'none',
                  fontWeight: 'bold',
                  '&.Mui-selected': {
                    color: 'orange',
                    backgroundColor: 'none',
                    borderBottom: '3px solid orange',
                    background: 'none',
                  },
                  '&.Mui-selected:hover': {
                    backgroundColor: 'transparent',
                  },
                }}
              >
                View Inventory
              </ToggleButton>
              <ToggleButton
                value={1}
                aria-label='Sell_to_buyer'
                sx={{
                  flex: 1,
                  border: 'none',
                  fontWeight: 'bold',
                  '&.Mui-selected': {
                    color: 'orange',
                    backgroundColor: 'none',
                    borderBottom: '3px solid orange',
                    background: 'none',
                  },
                  '&.Mui-selected:hover': {
                    backgroundColor: 'transparent',
                  },
                }}
              >
                Sell to Buyer
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
        )}

        <Grid
          container
          spacing={2}
          alignItems='center'
        >
          <Grid
            item
            xs={12}
            sm={4}
            md={3}
          >
            <FormControl fullWidth>
              <InputLabel id='state'>Select Company</InputLabel>
              <Select
                label='Select Company'
                onChange={handleCompanyChange}
                value={selectedCompany}
              >
                {companies.map((item) => (
                  <MenuItem
                    key={item.company_id}
                    value={item.company_id}
                  >
                    {item.company_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {!isMobile && (
            <Grid
              item
              xs={12}
              sm={8}
              md={9}
              sx={{
                display: { sm: 'block', md: 'flex' },
                justifyContent: { md: 'flex-end' },
              }}
            >
              <ToggleButtonGroup
                value={toggleSellToBuyer}
                exclusive
                onChange={handleToggleSellTobuyer}
                aria-label='text alignment'
              >
                <StyledToggleButton
                  value={0}
                  aria-label='Inventory'
                >
                  Inventory
                </StyledToggleButton>
                <StyledToggleButton
                  value={1}
                  aria-label='Sell_to_buyer'
                >
                  Sell to Buyer
                </StyledToggleButton>
              </ToggleButtonGroup>
            </Grid>
          )}

          {toggleButtonlist.length > 0 && (
            <Grid
              item
              xs={12}
              sx={{ justifyContent: 'flex-end' }}
            >
              {toggleSellToBuyer === 1 &&
                !isMobile &&
                selectedCompanyData?.is_inventory_homogeneous && (
                  <Grid
                    item
                    sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}
                  >
                    <Button
                      variant='text'
                      onClick={() => {
                        // Track navigation to cart without adding products

                        navigate('/fmcg/buyer-cart', {
                          state: { selectedCompany: selectedCompanyData },
                        });
                      }}
                    >
                      Sell without adding product
                    </Button>
                  </Grid>
                )}

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: { xs: 'space-between', md: 'flex-end' },
                }}
              >
                <ToggleButtonGroup
                  value={alignment}
                  exclusive
                  onChange={handleAlignment}
                  aria-label='text alignment'
                >
                  {toggleButtonlist.map((toggleButton) => (
                    <StyledToggleButton
                      key={toggleButton.value}
                      value={toggleButton.value}
                      aria-label={toggleButton.value}
                    >
                      {toggleButton.label}
                    </StyledToggleButton>
                  ))}
                </ToggleButtonGroup>
                <Stack
                  direction='row'
                  spacing={2}
                  justifyContent={'center'}
                >
                  <IconButton
                    color='primary'
                    sx={{ p: '10px' }}
                    aria-label='directions'
                    onClick={() => {
                      // Track filter button click
                      
                      setIsFiltersModalOpen(true);
                    }}
                  >
                    <FilterAlt />
                  </IconButton>
                  {toggleSellToBuyer === 1 && (
                    <Box sx={{ ml: 2 }}>
                      <CartBadge
                        cartItemList={cartItemList}
                        selectedCompanyData={selectedCompanyData}
                      />
                    </Box>
                  )}
                </Stack>
              </Box>
            </Grid>
          )}
        </Grid>
        {isLoading ? (
          <Box
            display='flex'
            justifyContent='center'
            alignItems='center'
            height={300}
          >
            <CircularProgress />
          </Box>
        ) : !isMobile ? (
          <Paper sx={{ width: '100%', mb: 2, mt: '1rem' }}>
            {products.length === 0 ? (
              <NoData
                text={
                  selectedFiltersList.length > 0
                    ? 'No Inventory found for selected Filter'
                    : inventoryMessage &&  inventoryMessage
                }
              />
            ) : (
              <TableContainer>
                <Table aria-label='simple table'>
                  <TableHead
                    sx={{ backgroundColor: 'rgba(217, 217, 217, .5)' }}
                  >
                    <TableRow>
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        #
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        Product Name
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        Company
                      </TableCell>
                      {showPriceColumn && (
                        <TableCell
                          align='center'
                          sx={{ fontWeight: 'bold' }}
                        >
                          Price
                        </TableCell>
                      )}
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        Available Qty
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        Unverified Qty
                      </TableCell>
                      <TableCell
                        align='center'
                        sx={{ fontWeight: 'bold' }}
                      >
                        UOM
                      </TableCell>
                      {toggleSellToBuyer === 1 && (
                        <TableCell
                          align='center'
                          sx={{ fontWeight: 'bold' }}
                        >
                          Action
                        </TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {products.length > 0 &&
                      products.map((row, index) => {
                        const itemInCart = cartItemList.find(
                          (item) =>
                            item.product_info.product_id ===
                            row.product_info.product_id,
                        );
                        return (
                          <TableRow
                            key={index}
                            sx={{
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              if (toggleSellToBuyer === 1) return;
                              
                              // Track product details drawer open

                              setSelectedProduct(row);
                              setIsDrawerOpen(true);
                            }}
                          >
                            <TableCell align='center'>{index + 1}</TableCell>
                            <TableCell align='center'>
                              {row?.product_info?.product_name}
                            </TableCell>
                            <TableCell align='center'>
                              {selectedCompanyData?.company_name}
                            </TableCell>
                            {showPriceColumn && (
                              <TableCell align='center'>
                                {row?.price_info?.mrp}
                              </TableCell>
                            )}
                            <TableCell align='center'>
                              {alignment
                                ? row?.allocable_quantity?.quantity_in_bags
                                : getQuantityInCasesUnit(
                                    row?.allocable_quantity
                                      ?.quantity_in_metric_ton,
                                    row?.allocable_quantity?.quantity_in_bags,
                                    row?.allocable_quantity?.multiplier,
                                    selectedCompanyData?.is_inventory_homogeneous,
                                    row?.allocable_quantity?.unit,
                                    row?.allocable_quantity?.base_unit,
                                  )}
                            </TableCell>
                            <TableCell align='center'>
                              {alignment
                                ? row?.blocked_quantity?.quantity_in_bags
                                : getQuantityInCasesUnit(
                                    row?.blocked_quantity
                                      ?.quantity_in_metric_ton,
                                    row?.blocked_quantity?.quantity_in_bags,
                                    row?.blocked_quantity?.multiplier,
                                    selectedCompanyData?.is_inventory_homogeneous,
                                    row?.blocked_quantity?.unit,
                                    row?.blocked_quantity?.base_unit,
                                  )}
                            </TableCell>
                            <TableCell align='center'>
                              {alignment
                                ? row?.allocable_quantity?.base_unit
                                : row?.allocable_quantity?.unit}
                            </TableCell>
                            {toggleSellToBuyer === 1 && (
                              <TableCell
                                align='center'
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                              >
                                <AddRemoveQtyButton
                                  onIncreasePress={() => {
                                    updateProdQty({ type: 'ADD', data: row });
                                  }}
                                  onReducePress={() => {
                                    updateProdQty({
                                      type: 'REMOVE',
                                      data: row,
                                    });
                                  }}
                                  quantity={
                                    itemInCart?.sellToBuyerQty?.qty || 0
                                  }
                                  onTextChange={(input) => {
                                    updateProdQty({
                                      type: 'ADD',
                                      data: row,
                                      inputValue: Number(input),
                                    });
                                  }}
                                />
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      })}
                    <TableRow>
                      {showPriceColumn && (
                        <TableCell rowSpan={0} />
                      )}
                      <TableCell
                        colSpan={
                          selectedCompanyData?.is_inventory_homogeneous ? 2 : 3
                        }
                        align='right'
                      >
                        Total Inventory
                      </TableCell>
                      <TableCell align='center'>{totalAvailableQty}</TableCell>
                      <TableCell align='center'>{totalBlockedQty}</TableCell>
                      <TableCell align='center'>
                        {alignment
                          ? selectedCompanyData?.allocable_quantity?.base_unit
                          : selectedCompanyData?.allocable_quantity?.unit}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        ) : (
          <Box>
            {products.length === 0 ? (
              <NoData text={
                  selectedFiltersList.length > 0
                    ? 'No Inventory found for selected Filter'
                    : inventoryMessage &&  inventoryMessage
                } />
            ) : (
              <Box sx={{ mt: 2 }}>
                {products.length > 0 &&
                  products.map((row, index) => {
                    const itemInCart = cartItemList.find(
                      (item) =>
                        item.product_info.product_id ===
                        row.product_info.product_id,
                    );
                    return (
                      <Card
                        key={index}
                        sx={{
                          cursor: 'pointer',
                          mb: 2,
                          boxShadow: 'none',
                          border: '1px solid rgba(0, 0, 0, 0.12)',
                          borderRadius: '5px',
                        }}
                      >
                        <CardContent>
                          <Grid
                            container
                            spacing={2}
                            sx={{
                              display: 'flex',
                              alignItems:
                                toggleSellToBuyer === 1
                                  ? 'flex-start'
                                  : 'center',
                            }}
                          >
                            <Grid
                              item
                              xs={3}
                              sm={2}
                            >
                              <Box>
                                <img
                                  style={{
                                    width: '100%',
                                    borderRadius: '5px',
                                  }}
                                  src={row?.product_info?.product_logo}
                                  alt={row?.product_info?.product_name}
                                />
                              </Box>
                            </Grid>
                            <Grid
                              item
                              xs={9}
                              sm={10}
                            >
                              <Typography
                                sx={{ fontWeight: 'bold', fontSize: '15px' }}
                              >
                                {row?.product_info?.product_name}
                              </Typography>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'ce nter',
                                }}
                              >
                                <Box>
                                  <Typography
                                    variant='body1'
                                    color='textSecondary'
                                    sx={{ fontSize: '14px' }}
                                  >
                                    {selectedCompanyData?.company_name}
                                  </Typography>
                                  {showPriceColumn && (
                                    <Typography variant='body2'>
                                      MRP: {row?.price_info?.mrp}
                                    </Typography>
                                  )}
                                  <Typography variant='body2'>
                                    Available Qty:{' '}
                                    {alignment
                                      ? row?.allocable_quantity
                                          ?.quantity_in_bags
                                      : getQuantityInCasesUnit(
                                          row?.allocable_quantity
                                            ?.quantity_in_metric_ton,
                                          row?.allocable_quantity
                                            ?.quantity_in_bags,
                                          row?.allocable_quantity?.multiplier,
                                          selectedCompanyData?.is_inventory_homogeneous,
                                          row?.allocable_quantity?.unit,
                                          row?.allocable_quantity?.base_unit,
                                        )}{' '}
                                  </Typography>
                                  <Typography variant='body2'>
                                    Unverified Qty:{' '}
                                    {alignment
                                      ? row?.blocked_quantity?.quantity_in_bags
                                      : getQuantityInCasesUnit(
                                          row?.blocked_quantity
                                            ?.quantity_in_metric_ton,
                                          row?.blocked_quantity
                                            ?.quantity_in_bags,
                                          row?.blocked_quantity?.multiplier,
                                          selectedCompanyData?.is_inventory_homogeneous,
                                          row?.blocked_quantity?.unit,
                                          row?.blocked_quantity?.base_unit,
                                        )}{' '}
                                  </Typography>
                                </Box>
                                <Box>
                                  {toggleSellToBuyer === 1 && (
                                    <Box mt={1}>
                                      <AddRemoveQtyButton
                                        onIncreasePress={() =>
                                          updateProdQty({
                                            type: 'ADD',
                                            data: row,
                                          })
                                        }
                                        onReducePress={() =>
                                          updateProdQty({
                                            type: 'REMOVE',
                                            data: row,
                                          })
                                        }
                                        quantity={
                                          itemInCart?.sellToBuyerQty?.qty || 0
                                        }
                                        onTextChange={(input) =>
                                          updateProdQty({
                                            type: 'ADD',
                                            data: row,
                                            inputValue: Number(input),
                                          })
                                        }
                                      />
                                    </Box>
                                  )}
                                </Box>
                              </Box>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    );
                  })}
              </Box>
            )}
          </Box>
        )}
      </Container>
      <Drawer
        anchor='right'
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
      >
        <Box
          sx={{ width: 400, mt: '2rem' }}
          role='presentation'
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <Typography
            variant='h6'
            sx={{ padding: 2 }}
            fontWeight={600}
          >
            Product Description
          </Typography>
          <Divider sx={{ mb: '2rem' }} />
          <Stack
            direction={'column'}
            spacing={2}
            sx={{ padding: 2 }}
          >
            <img
              src={selectedProduct?.product_info?.product_logo}
              alt={selectedProduct?.product_info?.product_name}
            />
            <Typography
              variant='subtitle1'
              fontWeight={600}
            >
              {selectedProduct?.product_info?.product_name}
            </Typography>
            <Typography variant='subtitle2'>
              {selectedCompanyData?.company_name}
            </Typography>
            <Typography
              variant='body1'
              fontSize={12}
            >
              {selectedProduct?.product_info?.product_description}
            </Typography>
            {selectedProduct?.price_info?.mrp && (
              <Typography variant='body1'>
                INR {selectedProduct?.price_info?.mrp}
              </Typography>
            )}
            {alignment ? (
              <Typography
                variant='subtitle1'
                fontWeight={600}
              >
                Available Qty:{' '}
                {selectedProduct?.allocable_quantity?.quantity_in_bags}{' '}
                {selectedProduct?.allocable_quantity?.base_unit}
              </Typography>
            ) : (
              <Typography
                variant='subtitle1'
                fontWeight={600}
              >
                Available Qty:{' '}
                {getQuantityInCasesUnit(
                  selectedProduct?.allocable_quantity?.quantity_in_metric_ton,
                  selectedProduct?.allocable_quantity?.quantity_in_bags,
                  selectedProduct?.allocable_quantity?.multiplier,
                  selectedCompanyData?.is_inventory_homogeneous,
                  selectedProduct?.allocable_quantity?.unit,
                  selectedProduct?.allocable_quantity?.base_unit,
                )}{' '}
                {selectedCompanyData?.is_inventory_homogeneous &&
                  selectedProduct?.allocable_quantity?.unit}
              </Typography>
            )}
            {alignment ? (
              <Typography
                variant='subtitle1'
                fontWeight={600}
              >
                Unverified Qty:{' '}
                {selectedProduct?.blocked_quantity?.quantity_in_bags}{' '}
                {selectedProduct?.blocked_quantity?.base_unit}
              </Typography>
            ) : (
              <Typography
                variant='subtitle1'
                fontWeight={600}
              >
                Unverified Qty:{' '}
                {getQuantityInCasesUnit(
                  selectedProduct?.blocked_quantity?.quantity_in_metric_ton,
                  selectedProduct?.blocked_quantity?.quantity_in_bags,
                  selectedProduct?.blocked_quantity?.multiplier,
                  selectedCompanyData?.is_inventory_homogeneous,
                  selectedProduct?.blocked_quantity?.unit,
                  selectedProduct?.blocked_quantity?.base_unit,
                )}{' '}
                {selectedCompanyData?.is_inventory_homogeneous &&
                  selectedProduct?.blocked_quantity?.unit}
              </Typography>
            )}
          </Stack>
        </Box>
      </Drawer>
      <Drawer
        anchor={'right'}
        open={isFiltersModalOpen}
        onClose={toggleFilterDrawer(false)}
      >
        <FilterComponent
          data={filters}
          selectedFiltersList={selectedFiltersList}
          setSelectedFiltersList={setSelectedFiltersList}
          setIsFiltersModalOpen={setIsFiltersModalOpen}
        />
      </Drawer>
      {toggleSellToBuyer === 1 &&
        isMobile &&
        selectedCompanyData?.is_inventory_homogeneous && (
          <Box
            sx={{
              position: 'fixed',
              bottom: 0,
              background: '#fff',
              padding: 2,
              width: '100%',
            }}
          >
            <Button
              variant='contained'
              fullWidth
              onClick={() => {
                // Track mobile navigation to cart without adding products

                navigate('/fmcg/buyer-cart', {
                  state: { selectedCompany: selectedCompanyData },
                });
              }}
            >
              Sell without adding product
            </Button>
          </Box>
        )}
    </Box>
  );
};

export default Inventory;
